import { commonIcons } from '@apps-common/config/icons'

export const NoControlsCard = () => (
  <div className='relative w-full pt-[100%] rounded-[30px] flex items-center justify-start gap-[0px] bg-surface text-text'>
    <div className='absolute top-0 left-0 flex flex-col items-center justify-center w-full h-[100%] gap-[5px] sm:gap-[10px]'>
      <div className='grow flex items-end justify-center w-full rounded-[40px] text-center'>
        <div className=' w-[40px] h-[40px] flex items-center justify-center p-[3px] rounded-full bg-surface-2'>
          <div className='absolute'>
            <div className='w-full h-[100%] rounded-[50%] flex items-center justify-center'>
              <commonIcons.info />
            </div>
          </div>
        </div>
      </div>

      <p className='grow uppercase text-[0.6rem]  sm:text-[0.7rem] leading-[0.8rem] jost text-center'>
        No controls
        <br />
        added
      </p>
    </div>
  </div>
)
